import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import Title from 'components/Title/Title';
import Layout from 'components/Layout/Layout';
import Keyboard from 'components/Keyboard/Keyboard';
import AuthStore from 'stores/Auth';
import { countryCodes } from 'config/country-codes';
import styles from './Signup.module.scss';

const Signup = observer(() => {

  const [ number, setNumber ] = useState('');
  const [ countryCode, setCountryCode ] = useState('US');
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthStore.token) {
      navigate('/auth/code');
    }
  }, [ AuthStore.token ]);

  function submit(event) {
    event.preventDefault();
    AuthStore.submitNumber(number, countryCode);
  }

  function onChange(value) {
    if (number.length >= 12) {
      return;
    }
    setNumber(number + value);
  }

  function onCorrectNumber() {
    setNumber(number?.slice(0, -1));
  }

  function codeToCallingCode(code) {
    return countryCodes.find(item => item.code === code)?.callingCode;
  }

  function format(value, pattern) {
    let i = 0;
    const v = value.toString();
    return pattern.replace(/#/g, _ => v[i++] ?? '');
  }

  return (
    <div className={classNames(styles.container, {
      // [styles.compact]: focused
      [styles.fetching]: AuthStore.fetching
    })}>
      <Layout>
        <Title>
          Enter your phone number to&nbsp;<strong>sign&nbsp;up</strong>
        </Title>
        {/* <form onSubmit={submit}> */}

          <div className={styles.numberWrapper}>
            <div className={styles.select}>
              <select onChange={event => setCountryCode(event.target.value)}>
                {countryCodes.map(code =>
                  <option key={code.code} value={code.code}>
                    +{code.callingCode} {code.name}
                  </option>  
                )}
              </select>
              <div className={styles.selectValue}>
                +{codeToCallingCode(countryCode)}
              </div>
            </div>

            <div className={styles.number}>
              {format(number, '### ### ######')}
            </div>

            <div className={styles.carret} />
          </div>

          {/* <input 
            className={styles.input} 
            type="number"
            pattern="[0-9]*" 
            inputMode="numeric"
            onFocus={event => setFocused(true)}
            onBlur={event => setFocused(false)}
          /> */}
          
        {/* </form> */}

        <Keyboard 
          onPress={onChange}
          onBack={onCorrectNumber}
          onSubmit={submit}
        />

        {/* <Button light>
          Send a Code
        </Button> */}

        <div className={styles.agreements}>
          By signing up you acknowledge that you read and agree to Go X <a href="https://goxapp.com/privacy-policy">Privacy Policy</a> and <a href="https://goxapp.com/user-agreement">User Agreement</a>
        </div>
      </Layout>
    </div>
  );
});

export default Signup;
